export const lyric09 = `All my friends are heathens, take it slow
Wait for them to ask you who you know
Please don't make any sudden moves
You don't know the half of the abuse
All my friends are heathens, take it slow
Wait for them to ask you who you know
Please don't make any sudden moves
You don't know the half of the abuse
Welcome to the room of people
Who have rooms of people that they loved one day
Docked away
Just because we check the guns at the door
Doesn't mean our brains will change from hand grenades
You'll never know the psychopath sitting next to you
You'll never know the murderer sitting next to you
You'll think, "How'd I get here, sitting next to you?"
But after all I've said, please don't forget
All my friends are heathens, take it slow
Wait for them to ask you who you know
Please don't make any sudden moves
You don't know the half of the abuse
We don't deal with outsiders very well
They say newcomers have a certain smell
You have trust issues, not to mention
They say they can smell your intentions
You'll never know the freak show sitting next to you
You'll have some weird people sitting next to you
You'll think "How did I get here, sitting next to you?"
But after all I've said, please don't forget
All my friends are heathens, take it slow
Wait for them to ask you who you know
Please don't make any sudden moves
You don't know the half of the abuse
All my friends are heathens, take it slow (Watch it)
Wait for them to ask you who you know (Watch it)
Please all my friends are heathens, take it slow (Watch it)
Wait for them to ask you who you know
Why'd you come? You knew you should have stayed
I tried to warn you just to stay away
And now they're outside ready to bust
It looks like you might be one of us`